<div class="note-block-cell">
  <label *ngIf="labelText" class="note-label">{{ labelText }}</label>

  <div class="note-tab-strip" *ngIf="hasTabs">
    <button type="button"
            class="note-tab"
            *ngFor="let tab of tabs; let i = index"
            [class.active]="i === activeTabIndex"
            [disabled]="isEditMode"
            (click)="selectTab(i)">
      {{ tab.label || '(unnamed)' }}
    </button>
  </div>

  <textarea
    class="note-textarea"
    [(ngModel)]="noteValue"
    (ngModelChange)="onNoteChange()"
    [placeholder]="placeholder"
    [disabled]="isEditMode"
  ></textarea>
</div>